<app-mobile-page-shell [hideBottomNav]="mobileView !== 'inventory'">

  <!-- Metric Ribbon — only shown on Tables view -->
  <!-- <app-mobile-metric-ribbon *ngIf="mobileView === 'inventory'" [metrics]="metricItems"></app-mobile-metric-ribbon> -->

  <!-- Scrollable content area -->
  <div class="inv-mobile-content">

    <!-- ── OVERVIEW VIEW ──────────────────────────────────────────── -->
    <div *ngIf="mobileView === 'overview'" class="inv-mobile-overview">

      <div class="m-dash-overview-card m-dash-overview-card--inventory mx-3 mt-3">
        <div class="m-dash-overview-header">
          <div class="m-dash-overview-icon m-dash-overview-icon--inventory">
            <i class="bi bi-box-seam"></i>
          </div>
          <div>
            <h6 class="m-dash-overview-title mb-0">Inventory Counts</h6>
            <small class="text-muted">Item counts &amp; low-stock alerts</small>
          </div>
        </div>
        <div class="m-dash-overview-row">
          <div class="m-dash-overview-item">
            <span class="m-dash-overview-label">Raw Materials</span>
            <span class="m-dash-overview-value">{{ totalRawMaterials }}</span>
          </div>
          <div class="m-dash-overview-item">
            <span class="m-dash-overview-label">Finished Products</span>
            <span class="m-dash-overview-value">{{ totalFinishedGoods }}</span>
          </div>
          <div class="m-dash-overview-item" (click)="openLowStockSheet()" style="cursor: pointer;">
            <span class="m-dash-overview-label">Low Stock</span>
            <span class="m-dash-overview-value" [class.text-danger]="lowStockItems > 0">
              {{ lowStockItems }}
              <i *ngIf="lowStockItems > 0" class="bi bi-chevron-right text-muted small ms-1"></i>
            </span>
          </div>
        </div>
      </div>

      <div class="m-dash-overview-card m-dash-overview-card--inventory mx-3 mt-3 mb-3">
        <div class="m-dash-overview-header">
          <div class="m-dash-overview-icon m-dash-overview-icon--inventory">
            <i class="bi bi-cash-coin"></i>
          </div>
          <div>
            <h6 class="m-dash-overview-title mb-0">Inventory Value</h6>
            <small class="text-muted">Raw material &amp; product totals</small>
          </div>
        </div>
        <div class="m-dash-overview-row">
          <div class="m-dash-overview-item">
            <span class="m-dash-overview-label">Raw Material Value</span>
            <span class="m-dash-overview-value">{{ totalRawMaterialValue | currency:'ZAR':'symbol':'1.2-2' }}</span>
          </div>
          <div class="m-dash-overview-item">
            <span class="m-dash-overview-label">Product Value</span>
            <span class="m-dash-overview-value">{{ totalProductValueFromBOM | currency:'ZAR':'symbol':'1.2-2' }}</span>
          </div>
          
          <div class="m-dash-overview-item m-dash-overview-item--total">
            <span class="m-dash-overview-label">Total</span>
            <span class="m-dash-overview-value fw-bold">
              {{ (totalRawMaterialValue + totalProductValueFromBOM) | currency:'ZAR':'symbol':'1.2-2' }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- ── RAW MATERIALS TAB ──────────────────────────────────────── -->
    <ng-container *ngIf="mobileView === 'inventory' && mobileActiveTab === 'raw'">
      <div class="m-section m-section--raw">

        <div class="m-section-header">
          <div class="m-section-icon"><i class="bi bi-box-seam"></i></div>
          <div class="m-section-header-text">
            <h6 class="m-section-title mb-0">Raw Materials</h6>
            <small class="m-section-subtitle text-muted">Manage stock levels and supplier sourcing</small>
          </div>
          <button class="btn btn-outline-primary btn-sm ms-auto" (click)="openMobileAddChoice('raw')">
            <i class="bi bi-plus-lg me-1"></i>Add
          </button>
        </div>

        <div class="m-cfg-toolbar m-cfg-toolbar--inline">
            <div class="m-cfg-search">
              <i class="bi bi-search"></i>
              <input type="text" [(ngModel)]="mobileRawSearch" (ngModelChange)="onRawFilterChange()" placeholder="Search name, SKU, category…" />
              <button *ngIf="mobileRawSearch" class="m-cfg-clear" (click)="mobileRawSearch=''; onRawFilterChange()">
                <i class="bi bi-x-circle-fill"></i>
              </button>
            </div>
            <button class="m-cfg-filter-toggle"
              [class.active]="mobileRawFiltersOpen || rawActiveFilterCount > 0"
              (click)="toggleRawFilters()">
              <i class="bi bi-funnel"></i>
              <span *ngIf="rawActiveFilterCount > 0" class="m-cfg-filter-badge">{{ rawActiveFilterCount }}</span>
            </button>
          <div class="m-cfg-filter-panel" *ngIf="mobileRawFiltersOpen">
            <div class="m-cfg-controls">
              <div class="m-cfg-sort-wrap">
                <button class="m-cfg-sort-btn" (click)="cycleSortRaw(mobileRawSortKey)">
                  <i class="bi" [ngClass]="mobileRawSortAsc ? 'bi-sort-alpha-down' : 'bi-sort-alpha-up'"></i>
                  {{ mobileRawSortKey === 'name' ? 'Name' : mobileRawSortKey === 'qty' ? 'Qty' : 'Value' }}
                </button>
                <button class="m-cfg-sort-btn m-cfg-sort-key-btn" (click)="cycleSortRaw(mobileRawSortKey === 'name' ? 'qty' : mobileRawSortKey === 'qty' ? 'value' : 'name')">
                  <i class="bi bi-arrow-repeat"></i>
                </button>
              </div>
              <button *ngIf="rawActiveFilterCount > 0" class="m-cfg-clear-link" (click)="clearRawFilters()">Clear</button>
            </div>
            <div class="m-cfg-select-row">
              <div class="m-cfg-select-group">
                <label class="m-cfg-select-label">Category</label>
                <app-single-select-dropdown
                  [options]="filterCategoryOptions"
                  [selectedValue]="mobileRawCategoryId != null ? String(mobileRawCategoryId) : null"
                  placeholder="All Categories"
                  (selectedValueChange)="mobileRawCategoryId = fromValue($event); onRawFilterChange()">
                </app-single-select-dropdown>
              </div>
              <div class="m-cfg-select-group">
                <label class="m-cfg-select-label">Unit of Measure</label>
                <app-single-select-dropdown
                  [options]="filterUomOptions"
                  [selectedValue]="mobileRawUomId != null ? String(mobileRawUomId) : null"
                  placeholder="All Units"
                  (selectedValueChange)="mobileRawUomId = fromValue($event); onRawFilterChange()">
                </app-single-select-dropdown>
              </div>
            </div>
            <div class="m-cfg-chips">
              <button class="m-cfg-chip" [class.active]="mobileRawStatus === 'all'" (click)="mobileRawStatus='all'; onRawFilterChange()">All</button>
              <button class="m-cfg-chip m-cfg-chip--low" [class.active]="mobileRawStatus === 'low'" (click)="mobileRawStatus='low'; onRawFilterChange()">Low Stock</button>
              <button class="m-cfg-chip m-cfg-chip--ok" [class.active]="mobileRawStatus === 'in'" (click)="mobileRawStatus='in'; onRawFilterChange()">In Stock</button>
            </div>
          </div>
        </div>
      </div>

      <div class="mobile-cards-area">
        <div *ngIf="rawMaterialsPaged.length === 0" class="inv-empty-state">
          <i class="bi bi-box-seam fs-2 text-muted d-block mb-2"></i>
          <p class="text-muted mb-2">{{ (mobileRawSearch || mobileRawCategoryId !== null || mobileRawStatus !== 'all') ? 'No items match your filters.' : 'No raw materials yet.' }}</p>
          <button *ngIf="!mobileRawSearch && mobileRawCategoryId === null && mobileRawStatus === 'all'" class="btn btn-sm inv-btn-add" (click)="openMobileAddChoice('raw')">
            <i class="bi bi-plus-circle me-1"></i>Add Raw Material
          </button>
        </div>

        <app-mobile-data-card
          *ngFor="let item of rawMaterialsPaged; let i = index"
          [title]="item.itemName"
          [fields]="rawFields(item)"
          [primaryValue]="'R ' + ((item.purchaseQuantity > 0 ? item.purchasePrice / item.purchaseQuantity : item.purchasePrice) | number:'1.2-2')"
          [badgeLabel]="'Raw Material'"
          [animationDelay]="i * 60"
          [fullItem]="item"
          (editTap)="openEditOffcanvas($event, 'raw')"
          (deleteTap)="openDeleteSheet($event, 'raw')">
        </app-mobile-data-card>

        <div *ngIf="rawMaterialsTotalPages > 1" class="inv-pagination">
          <button class="inv-page-btn" [disabled]="rawMaterialsCurrentPage === 1" (click)="changeRawPage(rawMaterialsCurrentPage - 1)">
            <i class="bi bi-chevron-left"></i>
          </button>
          <span class="inv-page-info">{{ rawMaterialsCurrentPage }} / {{ rawMaterialsTotalPages }}</span>
          <button class="inv-page-btn" [disabled]="rawMaterialsCurrentPage === rawMaterialsTotalPages" (click)="changeRawPage(rawMaterialsCurrentPage + 1)">
            <i class="bi bi-chevron-right"></i>
          </button>
        </div>
      </div>
    </ng-container>

    <!-- ── FINISHED PRODUCTS TAB ─────────────────────────────────── -->
    <ng-container *ngIf="mobileView === 'inventory' && mobileActiveTab === 'products'">
      <div class="m-section m-section--finished">

        <div class="m-section-header">
          <div class="m-section-icon"><i class="bi bi-bag-check"></i></div>
          <div class="m-section-header-text">
            <h6 class="m-section-title mb-0">Products</h6>
            <small class="m-section-subtitle text-muted">Manage products and bill of materials</small>
          </div>
          <button class="btn btn-outline-primary btn-sm ms-auto" (click)="openMobileAddChoice('product')">
            <i class="bi bi-plus-lg me-1"></i>Add
          </button>
        </div>

        <div class="m-cfg-toolbar m-cfg-toolbar--inline">
            <div class="m-cfg-search">
              <i class="bi bi-search"></i>
              <input type="text" [(ngModel)]="mobileProductSearch" (ngModelChange)="onProductFilterChange()" placeholder="Search name, SKU, category…" />
              <button *ngIf="mobileProductSearch" class="m-cfg-clear" (click)="mobileProductSearch=''; onProductFilterChange()">
                <i class="bi bi-x-circle-fill"></i>
              </button>
            </div>
            <button class="m-cfg-filter-toggle"
              [class.active]="mobileProductFiltersOpen || productActiveFilterCount > 0"
              (click)="toggleProductFilters()">
              <i class="bi bi-funnel"></i>
              <span *ngIf="productActiveFilterCount > 0" class="m-cfg-filter-badge">{{ productActiveFilterCount }}</span>
            </button>
          <div class="m-cfg-filter-panel" *ngIf="mobileProductFiltersOpen">
            <div class="m-cfg-controls">
              <div class="m-cfg-sort-wrap">
                <button class="m-cfg-sort-btn" (click)="cycleSortProduct(mobileProductSortKey)">
                  <i class="bi" [ngClass]="mobileProductSortAsc ? 'bi-sort-alpha-down' : 'bi-sort-alpha-up'"></i>
                  {{ mobileProductSortKey === 'name' ? 'Name' : mobileProductSortKey === 'qty' ? 'Qty' : 'Price' }}
                </button>
                <button class="m-cfg-sort-btn m-cfg-sort-key-btn" (click)="cycleSortProduct(mobileProductSortKey === 'name' ? 'qty' : mobileProductSortKey === 'qty' ? 'price' : 'name')">
                  <i class="bi bi-arrow-repeat"></i>
                </button>
              </div>
              <button *ngIf="productActiveFilterCount > 0" class="m-cfg-clear-link" (click)="clearProductFilters()">Clear</button>
            </div>
            <div class="m-cfg-select-row">
              <div class="m-cfg-select-group">
                <label class="m-cfg-select-label">Category</label>
                <app-single-select-dropdown
                  [options]="filterCategoryOptions"
                  [selectedValue]="mobileProductCategoryId != null ? String(mobileProductCategoryId) : null"
                  placeholder="All Categories"
                  (selectedValueChange)="mobileProductCategoryId = fromValue($event); onProductFilterChange()">
                </app-single-select-dropdown>
              </div>
            </div>
            <div class="m-cfg-chips">
              <button class="m-cfg-chip" [class.active]="mobileProductStatus === 'all'" (click)="mobileProductStatus='all'; onProductFilterChange()">All</button>
              <button class="m-cfg-chip m-cfg-chip--low" [class.active]="mobileProductStatus === 'low'" (click)="mobileProductStatus='low'; onProductFilterChange()">Low Stock</button>
              <button class="m-cfg-chip m-cfg-chip--ok" [class.active]="mobileProductStatus === 'in'" (click)="mobileProductStatus='in'; onProductFilterChange()">In Stock</button>
            </div>
          </div>
        </div>
      </div>

      <div class="mobile-cards-area">
        <div *ngIf="finishedGoodsPaged.length === 0" class="inv-empty-state">
          <i class="bi bi-bag-check fs-2 text-muted d-block mb-2"></i>
          <p class="text-muted mb-2">{{ (mobileProductSearch || mobileProductCategoryId !== null || mobileProductStatus !== 'all') ? 'No items match your filters.' : 'No products yet.' }}</p>
          <button *ngIf="!mobileProductSearch && mobileProductCategoryId === null && mobileProductStatus === 'all'" class="btn btn-sm inv-btn-add" (click)="openMobileAddChoice('product')">
            <i class="bi bi-plus-circle me-1"></i>Add Product
          </button>
        </div>

        <app-mobile-data-card
          *ngFor="let item of finishedGoodsPaged; let i = index"
          [title]="item.itemName"
          [fields]="productFields(item)"
          [primaryValue]="'R ' + (item.sellingPrice | number:'1.2-2')"
          [badgeLabel]="'Product'"
          [animationDelay]="i * 60"
          [fullItem]="item"
          (editTap)="openEditOffcanvas($event, 'product')"
          (deleteTap)="openDeleteSheet($event, 'product')">
        </app-mobile-data-card>

        <div *ngIf="finishedGoodsTotalPages > 1" class="inv-pagination">
          <button class="inv-page-btn" [disabled]="finishedGoodsCurrentPage === 1" (click)="changeFinishedPage(finishedGoodsCurrentPage - 1)">
            <i class="bi bi-chevron-left"></i>
          </button>
          <span class="inv-page-info">{{ finishedGoodsCurrentPage }} / {{ finishedGoodsTotalPages }}</span>
          <button class="inv-page-btn" [disabled]="finishedGoodsCurrentPage === finishedGoodsTotalPages" (click)="changeFinishedPage(finishedGoodsCurrentPage + 1)">
            <i class="bi bi-chevron-right"></i>
          </button>
        </div>
      </div>
    </ng-container>

    <!-- ── CHARTS VIEW ────────────────────────────────────────────── -->
    <div *ngIf="mobileView === 'charts'" class="inv-mobile-charts">

      <div class="m-section m-section--inv-raw">
          <div class="m-section-header">
            <div class="m-section-icon"><i class="bi bi-bar-chart-line"></i></div>
            <div class="m-section-header-text">
              <h6 class="m-section-title mb-0">Stock Value by Category</h6>
              <small class="m-section-subtitle text-muted">Value per category</small>
            </div>
          </div>
          <div class="inv-bar-chart-wrap" [style.height]="barChartWrapHeight">
            <div *ngIf="stackedBarData && stackedBarData.labels && stackedBarData.labels.length > 0; else noBarData" class="h-100">
              <app-reuseable-bar-chart
                [title]="''"
                [labels]="stackedBarData.labels"
                [data]="stackedBarData.datasets[0].data"
                [colors]="baseColors"
                [ItemsPerPage]="ItemsPerPage"
                [filters]="filters"
                [selectedFilter]="selectedFilter"
                [showFilters]="true"
                [currentPage]="currentPage"
                [totalPages]="totalPages"
                [totalItemsCount]="totalItemsCount"
                [goToPage]="goToPage"
                [pageSizeChange]="onPageSizeChange"
                [horizontal]="true"
                (filterChange)="filterChange.emit($event)"
                (pageChange)="pageChange.emit($event)">
              </app-reuseable-bar-chart>
            </div>
            <ng-template #noBarData>
              <div class="d-flex align-items-center justify-content-center h-100">
                <div class="text-center p-4">
                  <i class="bi bi-bar-chart fs-1 text-muted mb-2"></i>
                  <p class="mb-0 text-muted small">No data available</p>
                </div>
              </div>
            </ng-template>
          </div>
      </div>

      <div class="m-section m-section--inv-finished">
          <div class="m-section-header">
            <div class="m-section-icon"><i class="bi bi-pie-chart"></i></div>
            <div class="m-section-header-text">
              <h6 class="m-section-title mb-0">Stock Distribution by Category</h6>
              <small class="m-section-subtitle text-muted">Share of stock by category</small>
            </div>
          </div>
          <div class="inv-donut-wrap">
            <app-pie-chart
              *ngIf="categoryLabels.length > 0 && categoryData.length > 0"
              [labels]="categoryLabels"
              [data]="categoryData"
              [title]="''"
              [colors]="baseColors"
              [ItemsPerPage]="5"
              [compact]="true">
            </app-pie-chart>
            <div *ngIf="categoryLabels.length === 0 || categoryData.length === 0"
              class="d-flex align-items-center justify-content-center h-100">
              <div class="text-center p-4">
                <i class="bi bi-pie-chart fs-1 text-muted mb-2"></i>
                <p class="mb-0 text-muted small">No data available</p>
              </div>
            </div>
          </div>
      </div>

    </div>

    <!-- ── IMPORT VIEW ───────────────────────────────────────────── -->
    <div *ngIf="mobileView === 'import'" class="inv-mobile-import">

      <div class="m-section m-section--raw">
        <div class="m-section-header">
          <div class="m-section-icon"><i class="bi bi-file-earmark-arrow-down"></i></div>
          <div class="m-section-header-text">
            <h6 class="m-section-title mb-0">Download Template</h6>
            <small class="m-section-subtitle text-muted">Get the Excel template to fill in</small>
          </div>
        </div>
        <div class="m-import-template-row">
          <button class="m-cfg-action-btn--secondary" (click)="downloadTemplateMobile.emit()">
            <i class="bi bi-download me-1"></i>Raw Materials Template
          </button>
          <button class="m-cfg-action-btn--secondary" (click)="downloadFinishedTemplateMobile.emit()">
            <i class="bi bi-download me-1"></i>Products Template
          </button>
        </div>
      </div>

      <div class="m-section m-section--finished">
        <div class="m-section-header">
          <div class="m-section-icon"><i class="bi bi-cloud-arrow-up"></i></div>
          <div class="m-section-header-text">
            <h6 class="m-section-title mb-0">Import from Excel</h6>
            <small class="m-section-subtitle text-muted">Tap to choose a .xlsx file</small>
          </div>
        </div>

        <button class="m-import-dropzone" (click)="importFileInput.click()">
          <i class="bi bi-cloud-arrow-up-fill m-import-dropzone-icon"></i>
          <span class="m-import-dropzone-title">Tap to upload</span>
          <span class="m-import-dropzone-hint">.xlsx files only</span>
        </button>
        <input #importFileInput type="file" accept=".xlsx" hidden
               (change)="onMobileFileSelected($event)" />

        <p class="m-import-help text-muted small">
          Download the template above, fill in your data, then upload the completed file here.
        </p>
      </div>
    </div>

  </div>

</app-mobile-page-shell>

<!-- ── Edit / Add Offcanvas ──────────────────────────────────────────────────── -->
<app-inventory-item-offcanvas
  [visible]="mobileOffcanvasVisible"
  [mode]="mobileOffcanvasMode"
  [item]="mobileOffcanvasItem"
  [isEditing]="mobileOffcanvasIsEditing"
  [isAddingQuantity]="mobileOffcanvasIsAddingQuantity"
  [selectedItemForQtyAdd]="mobileOffcanvasSelectedItemForQty"
  [categories]="categories"
  [unitsOfMeasure]="unitsOfMeasure"
  [suppliers]="suppliers"
  [rawMaterials]="rawMaterials"
  (closeCanvas)="onOffcanvasClose()"
  (save)="onOffcanvasSave($event)"
  (addNewCategory)="onOffcanvasAddNewCategory()"
  (addNewSupplier)="onOffcanvasAddNewSupplier()">
</app-inventory-item-offcanvas>

<!-- ── Add Choice Bottom-Sheet ───────────────────────────────────────────────── -->
<div class="m-del-overlay"
  *ngIf="mobileAddChoiceVisible || mobileAddChoiceClosing"
  [style.opacity]="mobileAddChoiceClosing ? 0 : (mobileAddChoiceSwipeActive ? (1 - mobileAddChoiceSwipeProgress * 0.6) : null)"
  [style.transition]="mobileAddChoiceClosing ? 'opacity 0.28s ease' : null"
  (click)="$event.target === $event.currentTarget && closeMobileAddChoice()">

  <div class="m-del-sheet m-choice-sheet" (click)="$event.stopPropagation()"
    [style.transform]="mobileAddChoiceClosing ? 'translateY(100%)' : (mobileAddChoiceSwipeDeltaY ? 'translateY(' + mobileAddChoiceSwipeDeltaY + 'px)' : null)"
    [style.transition]="mobileAddChoiceClosing ? 'transform 0.3s cubic-bezier(0.4,0,0.2,1)' : (mobileAddChoiceSwipeActive ? 'none' : 'transform 0.3s cubic-bezier(0.4,0,0.2,1)')">

    <div class="m-del-handle-bar"
      (touchstart)="onAddChoiceTouchStart($event)"
      (touchmove)="onAddChoiceTouchMove($event)"
      (touchend)="onAddChoiceTouchEnd()">
      <div class="m-del-handle"
        [style.width.px]="36 + mobileAddChoiceSwipeProgress * 20"
        [style.background]="'rgb(' + Math.round(222 + mobileAddChoiceSwipeProgress * -222) + ',' + Math.round(226 + mobileAddChoiceSwipeProgress * (122 - 226)) + ',' + Math.round(230 + mobileAddChoiceSwipeProgress * (143 - 230)) + ')'">
      </div>
    </div>

    <div class="m-del-header">
      <h5 class="m-del-title">Add {{ mobileAddChoiceMode === 'raw' ? 'Raw Material' : 'Product' }}</h5>
      <button class="m-del-close-btn" (click)="closeMobileAddChoice()"><i class="bi bi-x-lg"></i></button>
    </div>
    <div class="m-del-body" style="display:flex; flex-direction:column; gap:12px; padding:16px;">
      <button class="btn btn-primary w-100 py-3" (click)="chooseAddNew()">
        <i class="bi bi-plus-circle me-2"></i>Add New Item
      </button>
      <button class="btn btn-outline-primary w-100 py-3" (click)="chooseAddQuantity()">
        <i class="bi bi-plus-square me-2"></i>Add Quantity to Existing Item
      </button>
    </div>
  </div>
</div>

<!-- ── Item Picker Bottom-Sheet ──────────────────────────────────────────────── -->
<div class="m-del-overlay"
  *ngIf="mobileItemPickerVisible || mobileItemPickerClosing"
  [style.opacity]="mobileItemPickerClosing ? 0 : (mobileItemPickerSwipeActive ? (1 - mobileItemPickerSwipeProgress * 0.6) : null)"
  [style.transition]="mobileItemPickerClosing ? 'opacity 0.28s ease' : null"
  (click)="$event.target === $event.currentTarget && closeItemPicker()">

  <div class="m-del-sheet m-picker-sheet" (click)="$event.stopPropagation()"
    style="max-height: 80vh;"
    [style.transform]="mobileItemPickerClosing ? 'translateY(100%)' : (mobileItemPickerSwipeDeltaY ? 'translateY(' + mobileItemPickerSwipeDeltaY + 'px)' : null)"
    [style.transition]="mobileItemPickerClosing ? 'transform 0.3s cubic-bezier(0.4,0,0.2,1)' : (mobileItemPickerSwipeActive ? 'none' : 'transform 0.3s cubic-bezier(0.4,0,0.2,1)')">

    <div class="m-del-handle-bar"
      (touchstart)="onItemPickerTouchStart($event)"
      (touchmove)="onItemPickerTouchMove($event)"
      (touchend)="onItemPickerTouchEnd()">
      <div class="m-del-handle"
        [style.width.px]="36 + mobileItemPickerSwipeProgress * 20"
        [style.background]="'rgb(' + Math.round(222 + mobileItemPickerSwipeProgress * -222) + ',' + Math.round(226 + mobileItemPickerSwipeProgress * (122 - 226)) + ',' + Math.round(230 + mobileItemPickerSwipeProgress * (143 - 230)) + ')'">
      </div>
    </div>

    <div class="m-del-header">
      <h5 class="m-del-title">Select Item</h5>
      <button class="m-del-close-btn" (click)="closeItemPicker()"><i class="bi bi-x-lg"></i></button>
    </div>
    <div style="padding: 0 16px 8px;">
      <div class="m-cfg-search">
        <i class="bi bi-search"></i>
        <input type="text" [(ngModel)]="mobileItemPickerSearch" placeholder="Search items…" />
        <button *ngIf="mobileItemPickerSearch" class="m-cfg-clear" (click)="mobileItemPickerSearch=''">
          <i class="bi bi-x-circle-fill"></i>
        </button>
      </div>
    </div>
    <div class="m-ls-body" style="overflow-y:auto; max-height:calc(80vh - 140px);">
      <div *ngFor="let item of mobileItemPickerFiltered" class="m-ls-row" (click)="selectItemForQtyAdd(item)">
        <div class="m-ls-row-info">
          <span class="m-ls-row-name">{{ item.itemName }}</span>
          <span class="m-ls-row-cat">SKU: {{ item.itemCode }} &nbsp;|&nbsp; Stock: {{ item.quantity ?? 0 }}</span>
        </div>
        <i class="bi bi-chevron-right text-muted small"></i>
      </div>
      <div *ngIf="mobileItemPickerFiltered.length === 0" class="text-center text-muted py-4 small">
        No items found.
      </div>
    </div>
  </div>
</div>

<!-- ── Category Create Bottom-Sheet ─────────────────────────────────────────── -->
<app-offcanvas-sheet
  [visible]="mobileCategoryCreateVisible"
  title="New Category"
  saveLabel="Create"
  [saveDisabled]="!newCategoryName.trim()"
  (closeCanvas)="closeCategoryCreateSheet()"
  (save)="submitNewCategory()">
  <div class="form-group-mobile">
    <label class="form-label fw-semibold">Category Name *</label>
    <input type="text" class="form-control" [(ngModel)]="newCategoryName" placeholder="e.g. Metals" autofocus />
  </div>
</app-offcanvas-sheet>

<!-- ── Delete Bottom-Sheet ───────────────────────────────────────────────────── -->
<div class="m-del-overlay"
  *ngIf="mobileDeleteVisible || mobileDeleteClosing"
  [style.opacity]="mobileDeleteClosing ? 0 : (mobileDeleteSwipeActive ? (1 - mobileDeleteSwipeProgress * 0.6) : null)"
  [style.transition]="mobileDeleteClosing ? 'opacity 0.28s ease' : null"
  (click)="$event.target === $event.currentTarget && closeDeleteSheet()">

  <div class="m-del-sheet" (click)="$event.stopPropagation()"
    [style.transform]="mobileDeleteClosing ? 'translateY(100%)' : (mobileDeleteSwipeDeltaY ? 'translateY(' + mobileDeleteSwipeDeltaY + 'px)' : null)"
    [style.transition]="mobileDeleteClosing ? 'transform 0.3s cubic-bezier(0.4,0,0.2,1)' : (mobileDeleteSwipeActive ? 'none' : 'transform 0.3s cubic-bezier(0.4,0,0.2,1)')">

    <div class="m-del-handle-bar"
      (touchstart)="onDeleteSheetTouchStart($event)"
      (touchmove)="onDeleteSheetTouchMove($event)"
      (touchend)="onDeleteSheetTouchEnd()">
      <div class="m-del-handle"
        [style.width.px]="36 + mobileDeleteSwipeProgress * 20"
        [style.background]="'rgb(' + Math.round(222 + mobileDeleteSwipeProgress * -222) + ',' + Math.round(226 + mobileDeleteSwipeProgress * (122 - 226)) + ',' + Math.round(230 + mobileDeleteSwipeProgress * (143 - 230)) + ')'">
      </div>
    </div>

    <div class="m-del-header">
      <h5 class="m-del-title">Remove Item</h5>
      <button class="m-del-close-btn" (click)="closeDeleteSheet()"><i class="bi bi-x-lg"></i></button>
    </div>
    <div class="m-del-body">
      <p class="m-del-text">
        Are you sure you want to <strong class="text-danger">deactivate </strong>
        <strong>{{ mobileDeleteItem?.itemName }}</strong>?
        This will remove it from your active inventory.
      </p>
    </div>
    <div class="m-del-footer">
      <button class="btn m-del-btn-cancel flex-fill" (click)="closeDeleteSheet()">Cancel</button>
      <button class="btn m-del-btn-confirm flex-fill" (click)="confirmDelete()">Remove</button>
    </div>
  </div>
</div>

<!-- ── Low-Stock Bottom-Sheet ────────────────────────────────────────────────── -->
<div class="m-ls-overlay"
  *ngIf="mobileLowStockVisible || mobileLowStockClosing"
  [style.opacity]="mobileLowStockClosing ? 0 : (mobileLowStockSwipeActive ? (1 - mobileLowStockSwipeProgress * 0.6) : null)"
  [style.transition]="mobileLowStockClosing ? 'opacity 0.28s ease' : null"
  (click)="$event.target === $event.currentTarget && closeLowStockSheet()">

  <div class="m-ls-sheet" (click)="$event.stopPropagation()"
    [style.transform]="mobileLowStockClosing ? 'translateY(100%)' : (mobileLowStockSwipeDeltaY ? 'translateY(' + mobileLowStockSwipeDeltaY + 'px)' : null)"
    [style.transition]="mobileLowStockClosing ? 'transform 0.3s cubic-bezier(0.4,0,0.2,1)' : (mobileLowStockSwipeActive ? 'none' : 'transform 0.3s cubic-bezier(0.4,0,0.2,1)')">

    <div class="m-ls-handle-bar"
      (touchstart)="onLowStockSheetTouchStart($event)"
      (touchmove)="onLowStockSheetTouchMove($event)"
      (touchend)="onLowStockSheetTouchEnd()">
      <div class="m-ls-handle"
        [style.width.px]="36 + mobileLowStockSwipeProgress * 20"
        [style.background]="'rgb(' + Math.round(222 + mobileLowStockSwipeProgress * -222) + ',' + Math.round(226 + mobileLowStockSwipeProgress * (122 - 226)) + ',' + Math.round(230 + mobileLowStockSwipeProgress * (143 - 230)) + ')'">
      </div>
    </div>

    <div class="m-ls-header">
      <h5 class="m-ls-title">Low Stock Items <span class="m-ls-count">{{ lowStockItemsCombined.length }}</span></h5>
      <button class="m-del-close-btn" (click)="closeLowStockSheet()"><i class="bi bi-x-lg"></i></button>
    </div>

    <div class="m-ls-body">
      <div *ngFor="let item of lowStockItemsCombined" class="m-ls-row" (click)="openEditFromLowStock(item)">
        <div class="m-ls-row-info">
          <span class="m-ls-row-name">{{ item.itemName }}</span>
          <span class="m-ls-row-cat">{{ item.CategoryName }}</span>
        </div>
        <div class="m-ls-row-right">
          <span class="m-ls-row-qty text-danger">{{ item.quantity ?? 0 }} / {{ item.lowStockThreshold ?? 0 }}</span>
          <i class="bi bi-chevron-right text-muted small"></i>
        </div>
      </div>
      <div *ngIf="lowStockItemsCombined.length === 0" class="text-center text-muted py-4 small">
        No low-stock items.
      </div>
    </div>
  </div>
</div>
